import React from 'react';
import Modifier from './components/Modifier';
import OutOfStockLable from './components/OutOfStockLable';
import { Modal, Media, ButtonToolbar, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { getOrderDetails } from '../dashboard/reducer';
import { updateCart } from '../dashboard/actions';
import {
  OUT_OF_STOCK,
  OUT_OF_STOCK_MODIFIER_LEVEL,
  OUT_OF_STOCK_ITEM_LEVEL,
} from '../../util/Constants';
import { parsePrice, GetCartItems, GetOrderType } from '../../lib/helper.js';
import { removeItemFromBag, goToCheckout } from '../dashboard/actions';
import { getItemTaxes, updateCartDetails } from '../../api/api';
import { getUserDetails, getTokenId, getJWT } from '../../redux/reducers/authenticationReducers';
import _lodash from 'lodash';
import defaultMsg from '../../translations/lang/en-US.json';

const MODE_ONE = 'ONE',
  MODE_MANY = 'MANY',
  MODE_ALL = 'ALL';

class OutOfStockItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      show: true,
      mode: MODE_ONE,
      redirecting: false,
      prepairingToCheckout: false,
      canceling: false,
      uniqueItems: [],
    };

    this.itemsOutOfStock = this.itemsOutOfStock.bind(this);
    this.handleBackToMenu = this.handleBackToMenu.bind(this);
    this.handleProceedToCheckout = this.handleProceedToCheckout.bind(this);
    this.getItemInStock = this.getItemInStock.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.reloadTaxes = this.reloadTaxes.bind(this);
    this.checkForOutOfStockItems = this.checkForOutOfStockItems.bind(this);
    this.updateCartDetails = this.updateCartDetails.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  componentWillMount() {
    this.checkForOutOfStockItems(this.props.outOfStockItems);
  }
  shouldComponentUpdate(nextProps, nextState) {
    this.setState({ show: nextProps.show });
    if (nextProps.outOfStockItems !== this.props.outOfStockItems) {
      this.checkForOutOfStockItems(nextProps.outOfStockItems);
    }
    return true;
  }
  updateCartDetails() {
    const {
      orderDetails,
      tokenId,
      jwt,
      dataname,
      loginUserDetails,
      locationid,
    } = this.props;
    return updateCartDetails({
      order_id: orderDetails.orderId,
      user_id: loginUserDetails ? loginUserDetails.id : 0,
      order_type: GetOrderType(orderDetails.modeOfOrder),
      delivery_fee:
        orderDetails.modeOfOrder === 2 ? orderDetails.deliveryFee : 0,
      cart_contents: GetCartItems([...orderDetails.items]),
      dataname,
      tokenId,
      jwt,
      locationid,
    });
  }

  reloadTaxes() {
    const { orderDetails, tokenId, jwt, dataname } = this.props;
    return getItemTaxes({
      cart_contents: GetCartItems([...orderDetails.items]),
      dataname,
      tokenId,
      jwt,
    });
  }

  checkForOutOfStockItems(items) {
    const outOfStockItems = this.itemsOutOfStock(items);
    let mode = '';
    const outStockItemCount = Number(outOfStockItems.length);
    if (outStockItemCount === Number(this.props.orderDetails.items.length)) {
      mode = MODE_ALL;
    } else if (outStockItemCount > 1) {
      mode = MODE_MANY;
    } else if (outStockItemCount === 1) {
      mode = MODE_ONE;
    }

    if (outOfStockItems.length > 0) {
      this.setState({
        items: outOfStockItems,
        mode: mode,
        uniqueItems: _lodash.uniqBy(outOfStockItems, 'id'),
      });
      this.reloadTaxes().then(response => {
        this.props
          .dispatch(goToCheckout(response.data.DataResponse))
          .then(this.updateCartDetails());
      });
    } else if (outOfStockItems.length === 0) {
      let itemsOutOfStockPresent = _lodash.remove(items, function(currentObject) {
        return currentObject.status === 'OutStock';
      });
      this.setState({
        items: itemsOutOfStockPresent,
        uniqueItems: itemsOutOfStockPresent,
      });
    }
  }

  handleBackToMenu() {
    const itemsInStock = this.getItemInStock();
    this.props
      .dispatch(removeItemFromBag(itemsInStock.items, itemsInStock.price))
      .then(() => {
        this.setState({
          redirecting: true,
        });
        this.reloadTaxes().then(response => {
          this.props
            .dispatch(goToCheckout(response.data.DataResponse))
            .then(() => {
              this.updateCartDetails().then(() => {
                window.location.href = '/' + this.props.rname;
              });
            });
        });
      });
  }

  handleCancel() {
    this.props.dispatch(removeItemFromBag([], 0, true)).then(() => {
      this.setState({
        canceling: true,
      });
      window.location.href = '/' + this.props.rname;
    });
  }

  getItemInStock() {
    let cartItems = _lodash.pullAllWith(
      [...this.props.orderDetails.items],
      this.state.items,
      !_lodash.isEqual
    );

    let totalCartPrice = _lodash.sumBy(cartItems, function(item) {
      return parseFloat(parsePrice(item.price, true));
    });

    return { items: cartItems, price: totalCartPrice };
  }

  handleProceedToCheckout() {
    if (this.state.items.length > 0) {
      this.setState({
        prepairingToCheckout: true,
      });
      const itemsInStock = this.getItemInStock();
      this.props
        .dispatch(removeItemFromBag(itemsInStock.items, itemsInStock.price))
        .then(() => {
          this.reloadTaxes().then(response => {
            this.props.close();
            this.props
              .dispatch(goToCheckout(response.data.DataResponse))
              .then(() => {
                this.updateCartDetails().then(this.props.proccedToCheckout());
              });
          });
        });
    }
  }
  onClose() {
    this.setState({ show: false });
    this.props.onClose();
  }
  itemsOutOfStock(outOfStockItems) {
    let cartItems = JSON.parse(JSON.stringify(this.props.orderDetails.items));
    let outStockItems = [];
    let itemLevel = [];
    let itemInStockCounts = {};
    let outOfStockModifiers = {};
    let availabilityCounts = {};

    cartItems.map((targetItem, key) => {
      let currentItemId = Number(targetItem.id);

      _lodash.forEach(outOfStockItems, function(outStockItem) {
        if (currentItemId === Number(outStockItem.itemId)) {
          let lookFor = outStockItem.itemId;

          switch (outStockItem.notavailable) {
            case OUT_OF_STOCK_ITEM_LEVEL:
              if (itemInStockCounts[lookFor] === undefined) {
                let instockCount = Number(outStockItem.instock);
                itemInStockCounts[lookFor] = Number(instockCount);
                availabilityCounts[lookFor] = instockCount;
              }

              if (availabilityCounts[lookFor]) {
                targetItem['instockCount'] = availabilityCounts[lookFor];
              }

              if (itemInStockCounts[lookFor] < 1) {
                targetItem['notavailable'] = outStockItem.notavailable;
                targetItem['availability'] = OUT_OF_STOCK;

                itemLevel.push(outStockItem.itemId);
              }
              break;

            case OUT_OF_STOCK_MODIFIER_LEVEL:
              if (outStockItem.instock) {
                outStockItem.instock.forEach(function(modifierInStockCount) {
                  let modifierId = Object.keys(modifierInStockCount)[0];
                  let count = modifierInStockCount[modifierId];
                  if (modifierId) {
                    if (outOfStockModifiers[modifierId] === undefined) {
                      outOfStockModifiers[Number(modifierId)] = count;
                    }
                  }
                });

                if (!_lodash.includes(itemLevel, outStockItem.itemId)) {
                  targetItem['notavailable'] = outStockItem.notavailable;
                }
              }
              break;
          }
        }
      });

      if (itemInStockCounts[currentItemId]) {
        itemInStockCounts[currentItemId] -= 1;
      }

      const filteredForcedModifiers = this.markOutOfStockForModifiers({
        modifiers: targetItem['forced'],
        outOfStockModifiers: outOfStockModifiers,
        status: false,
      });

      const filteredOptionalModifiers = this.markOutOfStockForModifiers({
        modifiers: targetItem['optional'],
        outOfStockModifiers: outOfStockModifiers,
        status: false,
      });

      if (
        (targetItem['notavailable'] === OUT_OF_STOCK_MODIFIER_LEVEL &&
          !filteredForcedModifiers.status &&
          !filteredOptionalModifiers.status) ||
        !targetItem['notavailable']
      ) {
        targetItem['notavailable'] = '';
      } else {
        outStockItems.push(targetItem);
        if (filteredForcedModifiers.modifiers) {
          targetItem['forced'] = filteredForcedModifiers.modifiers;
        }

        if (filteredOptionalModifiers.modifiers) {
          targetItem['optional'] = filteredOptionalModifiers.modifiers;
        }
      }
      return targetItem;
    });
    this.props.dispatch(updateCart(cartItems));

    return outStockItems;
  }

  markOutOfStockForModifiers = options => {
    if (!options.modifiers) {
      return { modifiers: [], outOfStockModifiers: [], status: false };
    }

    options.modifiers.map((data, key) => {
      const itemKey = key;
      if (data.option && data.option.length > 0 && data.selected) {
        let fillteredOpt = this.markOutOfStockForModifiers({
          modifiers: data.option,
          outOfStockModifiers: options.outOfStockModifiers,
          status: options.status,
        });
        options.status = fillteredOpt.status;
      }
      if (data.doption && data.doption.length > 0 && data.selected) {
        let fillteredOpt = this.markOutOfStockForModifiers({
          modifiers: data.doption,
          outOfStockModifiers: options.outOfStockModifiers,
          status: options.status,
        });
        options.status = fillteredOpt.status;
      }
      if (data.isChecked) {
        let modifierId = Number(options.modifiers[itemKey].id);
        if (
          options.modifiers[itemKey] &&
          options.outOfStockModifiers[modifierId] < 1
        ) {
          options.status = true;
          options.modifiers[itemKey]['availability'] = OUT_OF_STOCK;
        } else {
          if (options.outOfStockModifiers[modifierId]) {
            if (!options.modifiers[itemKey]['instockCount']) {
              options.modifiers[itemKey]['instockCount'] =
                options.outOfStockModifiers[modifierId];
            }

            options.outOfStockModifiers[modifierId] -= 1;
          }
        }
      }
    });
    return options;
  };

  render() {
    if (
      (this.props.cartItems === undefined || this.props.cartItems === null) &&
      this.state.items.length < 1
    ) {
      return null;
    }
    return (
      <Modal show={this.state.show}>
        <Modal.Header>
          <h4 className="modal-title olo-client-theme-color font-medium text-center">
            <FormattedMessage
              id="outOfStockHeader"
              defaultMessage={defaultMsg.outOfStockHeader}
            />
          </h4>
          <div className="text-center font-small-xs">
            {this.state.mode === MODE_ONE || this.state.mode === MODE_MANY ? (
              <FormattedMessage
                id="outOfStockOneOrMore"
                defaultMessage={defaultMsg.outOfStockOneOrMore}
              />
            ) : null}
            {this.state.mode === MODE_ALL ? (
              <FormattedMessage
                id="outOfStockAll"
                defaultMessage={defaultMsg.outOfStockAll}
              />
            ) : null}
          </div>
        </Modal.Header>
        <Modal.Body className="out-of-stock-list overflow-auto">
          <Media.List>
            {this.state.uniqueItems.map((item, key) => {
              return (
                <Media.ListItem key={_lodash.uniqueId('outOfStockItem_')}>
                  <Media.Left>
                    {item.image ? (
                      <img
                        width={64}
                        height={64}
                        src={item.image}
                        alt={item.name}
                      />
                    ) : null}
                  </Media.Left>
                  <Media.Body>
                    <Media.Heading className="font-medium">
                      {item.name}
                      {item.instockCount ? (
                        <div className="font-small-xs available-header-text">
                          {` - Available ${item.instockCount}`}
                        </div>
                      ) : null}
                    </Media.Heading>
                    <OutOfStockLable notavailable={item.notavailable} />
                    <div className="font-small-xs">
                      <Modifier item={item} />
                    </div>
                  </Media.Body>
                </Media.ListItem>
              );
            })}
          </Media.List>
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className="text-center">
            {this.state.mode === MODE_ALL ? (
              <Button
                bsSize="small"
                className="float-none inactive"
                onClick={this.handleCancel}
              >
                {this.state.canceling === true ? (
                  <FormattedMessage
                    id="redirectingToHome"
                    defaultMessage={defaultMsg.redirectingToHome}
                  />
                ) : (
                  <FormattedMessage
                    id="cancelOrder"
                    defaultMessage={defaultMsg.cancelOrder}
                  />
                )}
              </Button>
            ) : (
              <div>
                {this.props.cartItems === undefined ||
                this.props.cartItems === null ? (
                  <div>
                <Button
                  bsSize="small"
                  className="float-none inactive"
                  onClick={this.handleProceedToCheckout}
                >
                  {this.state.prepairingToCheckout === true ? (
                    <FormattedMessage
                      id="preparingForCheckout"
                      defaultMessage={defaultMsg.preparingForCheckout}
                    />
                  ) : (
                    <FormattedMessage
                      id="proceedToCheckout"
                      defaultMessage={defaultMsg.proceedToCheckout}
                    />
                  )}
                </Button>
                <Button
                  bsSize="small"
                  className="float-none inactive"
                  onClick={this.handleBackToMenu}
                >
                  {this.state.redirecting === true ? (
                    <FormattedMessage
                      id="redirectingToHome"
                      defaultMessage={defaultMsg.redirectingToHome}
                    />
                  ) : (
                    <FormattedMessage
                      id="editCart"
                      defaultMessage={defaultMsg.editCart}
                    />
                  )}
                </Button>
              </div>
                ) : (
                  <Button
                    bsSize="small"
                    className="float-none inactive"
                    onClick={this.onClose}
                  >
                    <FormattedMessage 
                      id="ok" 
                      defaultMessage={defaultMsg.ok} 
                    />
                  </Button>
            )}
              </div>
            )}
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    orderDetails: getOrderDetails(state),
    dataname: state.dashboard.dataName,
    loginUserDetails: getUserDetails(state),
    tokenId: getTokenId(state),
    jwt: getJWT(state),
    locationid: state.dashboard.merchantDetails.locationid,
  };
}

export default connect(mapStateToProps)(OutOfStockItems);



// WEBPACK FOOTER //
// ./src/views/inventory/OutOfStockItems.jsx